import { appName, defaultLogo } from './config';

export default {
    appName: appName,
    logo: defaultLogo,
    title: 'Health Clinic',
    project: 'hc',
    nav: [
        {
            name: 'Dashboard',
            icon: 'ti-dashboard',
            p: '/overview',
        },
        // {
        //     name: 'Assign Users',
        //     icon: 'ti-check-box',
        //     p: '/users',
        // },
        {
            name: 'Manage Users',
            icon: 'ti-user',
            path: 'share-project',
            p: '/share-project',
        },
        {
            name: 'Manage Community',
            icon: 'ti-view-list',
            p: '/communities',
        },
        {
            name: 'Records',
            icon: 'ti-view-list-alt',
            id: 'third-party',
            p: '/records',
        },
        {
            name: 'Archived Records',
            icon: 'ti-view-list-alt',
            id: 'third-party',
            p: '/archived-records',
        },
        {
            name: 'Reports',
            icon: 'ti-bar-chart-alt',
            id: 'third-party',
            children: [
                {
                    name: 'Owner/Clinic Map',
                    p: '/report/map',
                },
                {
                    name: 'Users',
                    p: '/report/users',
                }
            ],
        },
        {
            name: 'Survey Analysis',
            icon: 'ti-bar-chart-alt',
            p: '/survey/analysis',
        },
        {
            name: 'Settings',
            icon: 'nc-icon nc-settings',
            p: '/settings',
        }
    ],
};
